export default "__VITE_ASSET__08b7456e__"